import { useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { installAuthRuntime } from "./auth/runtime";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { SessionStatus } from "./pages/SessionStatus";
import { Devices } from "./pages/Devices";
import { Approvals } from "./pages/Approvals";
import { ApprovalDetail } from "./pages/ApprovalDetail";
import { ApprovalsHistory } from "./pages/ApprovalsHistory";
import { SettlementControl } from "./pages/SettlementControl";
import { EscrowBuckets } from "./pages/EscrowBuckets";
import { MoneyOperations } from "./pages/MoneyOperations";
import { MoneyDashboard } from "./pages/MoneyDashboard";
import { PartnerPayables } from "./pages/PartnerPayables";
import { PartnerPayableDetail } from "./pages/PartnerPayableDetail";
import { TreasurySummaryPage } from "./pages/TreasurySummaryPage";
import { WithdrawAffiliate } from "./pages/WithdrawAffiliate";
import { WithdrawTreasury } from "./pages/WithdrawTreasury";
import { RefundCandidates } from "./pages/RefundCandidates";
import { RefundDetail } from "./pages/RefundDetail";
import { AffiliateWithdrawals } from "./pages/AffiliateWithdrawals";
import { AffiliateWithdrawalDetail } from "./pages/AffiliateWithdrawalDetail";
import { AffiliateRedemptions } from "./pages/AffiliateRedemptions";
import { AffiliateRedemptionDetail } from "./pages/AffiliateRedemptionDetail";
import { PartnerApplications } from "./pages/PartnerApplications";
import { PartnerApplicationDetail } from "./pages/PartnerApplicationDetail";
import { ControlPlaneOverview } from "./pages/ControlPlaneOverview";
import { ControlPlaneProduct } from "./pages/ControlPlaneProduct";
import { ControlPlaneEditor } from "./pages/ControlPlaneEditor";
import { ControlPlaneReview } from "./pages/ControlPlaneReview";
import { ControlPlaneAudit } from "./pages/ControlPlaneAudit";

export function App() {
  // Subscribe to the wallet. Before Phase 1 this console listened to nothing:
  // `accountsChanged` and `chainChanged` appeared nowhere in the source, so an
  // operator could switch to a non-owner account, or to another network, and
  // the header would go on presenting the previous signer's authority
  // indefinitely. See `src/auth/provider-events.ts` for what each event means.
  useEffect(() => installAuthRuntime(), []);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/session" element={<SessionStatus />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/approvals" element={<Approvals />} />
          <Route path="/approvals/history" element={<ApprovalsHistory />} />
          <Route path="/approvals/:id" element={<ApprovalDetail />} />
          <Route path="/settlement-control" element={<SettlementControl />} />
          {/* Product Control Plane — the product DATA Gao apps read at runtime.
              Not this platform's deployment control plane; the two share a
              phrase and nothing else. */}
          <Route path="/control-plane" element={<ControlPlaneOverview />} />
          <Route path="/control-plane/:productId" element={<ControlPlaneProduct />} />
          <Route path="/control-plane/:productId/edit" element={<ControlPlaneEditor />} />
          <Route path="/control-plane/:productId/review" element={<ControlPlaneReview />} />
          <Route path="/control-plane/:productId/audit" element={<ControlPlaneAudit />} />
          <Route path="/dashboard" element={<MoneyDashboard />} />
          <Route path="/treasury" element={<TreasurySummaryPage />} />
          <Route path="/admin/partner-payables" element={<PartnerPayables />} />
          <Route
            path="/admin/partner-payables/:id"
            element={<PartnerPayableDetail />}
          />
          <Route path="/money" element={<MoneyOperations />} />
          <Route path="/escrow/buckets" element={<EscrowBuckets />} />
          <Route path="/escrow/withdraw-affiliate" element={<WithdrawAffiliate />} />
          <Route path="/escrow/withdraw-treasury" element={<WithdrawTreasury />} />
          <Route path="/escrow/refunds" element={<RefundCandidates />} />
          <Route
            path="/escrow/refunds/:paymentIntentId"
            element={<RefundDetail />}
          />
          <Route
            path="/admin/affiliate/withdrawals"
            element={<AffiliateWithdrawals />}
          />
          <Route
            path="/admin/affiliate/withdrawals/:id"
            element={<AffiliateWithdrawalDetail />}
          />
          <Route
            path="/admin/affiliate/redemptions"
            element={<AffiliateRedemptions />}
          />
          <Route
            path="/admin/affiliate/redemptions/:id"
            element={<AffiliateRedemptionDetail />}
          />
          <Route
            path="/admin/affiliate/partners"
            element={<PartnerApplications />}
          />
          <Route
            path="/admin/affiliate/partners/:id"
            element={<PartnerApplicationDetail />}
          />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
